import React from 'react';
import { useTranslation } from 'react-i18next';
import { CloseOutlined } from '@ant-design/icons';
import { Dropdown } from 'antd';
import { GetDetailSaleResponse } from '@esg/business-pos';
import { AppButton, FlexBox, Header, IconActivityHistory, IconCancelSale, IconMinimize, IconMore, IconPinMinimize, TextCommon } from '..';
import { translateCodes } from '../../locales';

interface HeaderDrawerProps {
    sale?: GetDetailSaleResponse;
    drawerTitle?: React.ReactNode;
    drawerTitleAction?: React.ReactNode;
    drawerSubtitle?: React.ReactNode;
    onMinimize?: () => void;
    handleSaveUnpaid?: () => Promise<void>;
    onClose?: (e: React.MouseEvent | React.KeyboardEvent) => void;
    readonly isFastSale?: boolean;
    readonly showModalOrderActivities?: () => void;
    readonly showModalConfirmCancel?: (sale: GetDetailSaleResponse) => void;
    disableCanceled?: boolean;
}

export const HeaderDrawer = (props: HeaderDrawerProps) => {
    const { t } = useTranslation();
    const { isFastSale } = props;

    const items = [
        {
            key: 'activity',
            label: (
                <FlexBox gap={12} alignItems='center'>
                    <IconActivityHistory />
                    <TextCommon translateCode={translateCodes.ACTIVITY_HISTORY} />
                </FlexBox>
            ),
            onClick: props.showModalOrderActivities
        },
        {
            key: 'close',
            label: (
                <FlexBox gap={12} alignItems='center'>
                    <IconPinMinimize />
                    <TextCommon translateCode={translateCodes.PIN_TO_MINIMIZE} />
                </FlexBox>
            ),
            onClick: props.handleSaveUnpaid,
        },
        {
            key: 'cancel',
            label: (
                <FlexBox gap={12} alignItems='center'>
                    <IconCancelSale />
                    <TextCommon translateCode={translateCodes.CANCEL_SALE} color='#D92D20' />
                </FlexBox>
            ),
            onClick: () => props.showModalConfirmCancel?.(props.sale!),
            disabled: props.disableCanceled
        },
    ];

    return (
        <FlexBox direction='row'>
            {typeof props.drawerTitle === 'string' ? (
                <FlexBox direction='column' alignItems='flex-start' justifyContent='center'>
                    <Header level={2}>
                        {t(props?.drawerTitle ?? '')}
                    </Header>
                    {props.drawerSubtitle &&
                        <TextCommon color='#344054' fontSize={12} fontWeight={400}>
                            {typeof props.drawerSubtitle === 'string' ?
                                t(props?.drawerSubtitle ?? '')
                                : props.drawerSubtitle}
                        </TextCommon>}
                </FlexBox>
            ) : (
                props.drawerTitle
            )}
            {
                isFastSale && <FlexBox gap={12} direction='row' justifyContent='flex-end' alignItems='center'>
                    <Dropdown menu={{
                        items: items,
                        onClick: ({ key }) => items.find((item) => item.key === key)?.onClick?.(),
                    }}
                        placement='bottomLeft' arrow>
                        <AppButton className='fast-activity-button'>
                            <IconMore />
                        </AppButton>
                    </Dropdown>
                </FlexBox>
                || <FlexBox gap={12} direction='row' justifyContent='flex-end' alignItems='center'>
                    {props?.onMinimize && <span className='minimizeButton'><IconMinimize onClick={props?.onMinimize} /></span>}
                    {props.drawerTitleAction}
                    <CloseOutlined onClick={props?.onClose} className='closeButton' />
                </FlexBox>
            }

        </FlexBox>
    );
};

